import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import UserService from "apiService/permissions";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useDeleteRole = (onClose) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.DELETE_ROLE],
    (id) => UserService.deleteRole(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_ROLES);
        onClose();
        toast.success("Role deleted successfully");
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );
};

export default useDeleteRole;
